// importation components
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Products from "./components/products";
import Prodct from "./components/Product";

// importation fouter dom
import { Route , Routes } from "react-router-dom";
import Cart from "./components/cart";

function App() {
    return (
        <div className="App">
            <Navbar />
            <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/Products" element={<Products />} />
                <Route path="/producs/:id" element={<Prodct />} />
                <Route path="/cart" element={<Cart />} />
            </Routes>
        </div>
    );
}

export default App;
